import OfferingCardBuilder from 'components/OfferingCardBuilder';
import React from 'react';
import {
  PremiumSessionUserFacingStatus,
  PremiumSession,
  SessionDefinition,
  EnhancedPremiumSession,
  PremiumSessionAggregate,
} from 'types/premiumSession';

export type SessionInfo = {
  attendedSession?: EnhancedPremiumSession;
  currentSessionDocId?: string;
  nextSchedulableSession?: PremiumSession;
  sessionWithEnrollment?: EnhancedPremiumSession;
  modulesContentItems: Record<string, number[]>;
  userFacingStatus: PremiumSessionUserFacingStatus;
};

type PremiumSessionCardProps = {
  children?: React.ReactNode;
  className?: string;
  premiumSessionAggregate?: PremiumSessionAggregate;
  hideAllActionButtons?: boolean;
  sessionDefinition: SessionDefinition;
  sessionInfo: SessionInfo;
};

const PremiumSessionCard: React.FC<PremiumSessionCardProps> = ({
  children,
  className = '',
  hideAllActionButtons = false,
  premiumSessionAggregate,
  sessionDefinition,
  sessionInfo,
}) => {
  const entry = premiumSessionAggregate?.catalogEntry;
  const courseSKU = premiumSessionAggregate?.content?.doc_id
    ?.split('-')?.[0]
    .toUpperCase();
  const offeringSlug = premiumSessionAggregate?.content?.offering_slug;

  const fullSessionSlug = `${offeringSlug}-${sessionDefinition.slug}`;

  const {
    attendedSession,
    currentSessionDocId,
    sessionWithEnrollment,
    modulesContentItems,
    userFacingStatus,
  } = sessionInfo;

  return (
    <OfferingCardBuilder
      className={className}
      entry={entry}
      premiumSessionSlug={fullSessionSlug}
      premiumSessionStatus={userFacingStatus}
    >
      <OfferingCardBuilder.Header />
      <OfferingCardBuilder.Body
        attendedSessionDate={attendedSession?.start_time}
        schedulledSessionDate={sessionWithEnrollment?.start_time}
        sessionModulesContent={modulesContentItems}
        skuLabel={courseSKU}
        title={sessionDefinition.title}
      />
      <OfferingCardBuilder.Footer
        hideAllActionButtons={hideAllActionButtons}
        sessionDocId={currentSessionDocId}
      >
        {children}
      </OfferingCardBuilder.Footer>
    </OfferingCardBuilder>
  );
};

export default PremiumSessionCard;
